import { exportErrorFragment } from "@saleor/fragments/errors";
import { exportFileFragment } from "@saleor/fragments/products";
import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import {
  SubscriptionBulkDelete,
  SubscriptionBulkDeleteVariables
} from "./types/SubscriptionBulkDelete";
import {
  SubscriptionCreate,
  SubscriptionCreateVariables
} from "./types/SubscriptionCreate";
import {
  SubscriptionDelete,
  SubscriptionDeleteVariables
} from "./types/SubscriptionDelete";
import {
  SubscriptionExport,
  SubscriptionExportVariables
} from "./types/SubscriptionExport"
import {
  SubscriptionUpdate,
  SubscriptionUpdateVariables
} from "./types/SubscriptionUpdate";

const subscriptionBulkDelete = gql`
  mutation SubscriptionBulkDelete($ids: [ID!]!) {
    subscriptionBulkDelete(ids: $ids) {
      errors: subscriptionErrors {
        message
      }
    }
  }
`;

export const useSubscriptionBulkDeleteMutation = makeMutation<
  SubscriptionBulkDelete,
  SubscriptionBulkDeleteVariables
>(subscriptionBulkDelete);

const subscriptionCreate = gql`
  mutation SubscriptionCreate($input: SubscriptionInput!) {
    subscriptionCreate(input: $input) {
      subscription {
        id
      }
      errors: subscriptionErrors {
        field
        code
      }
    }
  }
`;

export const useSubscriptionCreateMutation = makeMutation<
  SubscriptionCreate,
  SubscriptionCreateVariables
>(subscriptionCreate);

const subscriptionDelete = gql`
  mutation SubscriptionDelete($id: ID!) {
    subscriptionDelete(id: $id) {
      errors: subscriptionErrors {
        message
      }
    }
  }
`;

export const useSubscriptionDeleteMutation = makeMutation<
  SubscriptionDelete,
  SubscriptionDeleteVariables
>(subscriptionDelete);

const subscriptionUpdate = gql`
  mutation SubscriptionUpdate($id: ID!, $input: SubscriptionInput!) {
    subscriptionUpdate(id: $id, input: $input) {
      errors: subscriptionErrors {
        field
        code
      }
    }
  }
`;

export const useSubscriptionUpdateMutation = makeMutation<
  SubscriptionUpdate,
  SubscriptionUpdateVariables
>(subscriptionUpdate);

export const subscriptionExportMutation = gql`
  ${exportFileFragment}
  ${exportErrorFragment}
  mutation SubscriptionExport($input: ExportSubscriptionsInput!) {
    exportSubscriptions(input: $input) {
      exportFile {
        ...ExportFileFragment
      }
      errors: exportErrors {
        ...ExportErrorFragment
      }
    }
  }
`;

export const useSubscriptionExport = makeMutation<
  SubscriptionExport,
  SubscriptionExportVariables
>(subscriptionExportMutation);
